import styled from "styled-components"

export const Button = styled.div`
  position: fixed;
  right: 5%;
  bottom: 10%;
  height: 20px;
  font-size: 3rem;
  z-index: 1;
  cursor: pointer;
  color: var(--custom-primary);
  outline: none !important;
  &:focus {
    outline: none !important;
  }
  &:active {
    outline: none !important;
  }
`
